import * as React from "react";
import { EventTabColor } from "#src/components/svg/constants";
import { EventTabWizardSvgProps } from "#src/components/svg/types";

export const MiniFileSvg: React.FC<EventTabWizardSvgProps> = (props) => {
	const { color, ...rest } = props;

	let fillColor = EventTabColor.DEFAULT;

	if (color === "active") {
		fillColor = EventTabColor.ACTIVE;
	}

	if (color === "error") {
		fillColor = EventTabColor.ERROR;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={24}
			height={24}
			viewBox="0 0 24 24"
			fill="none"
			{...rest}
		>
			<path
				opacity={0.32}
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.9114 8.22695C19.4717 8.5891 17.7718 8.61315 16.3035 8.1646C15.6828 7.97495 15.1988 7.4914 14.9893 6.8771C14.4674 5.34677 14.3385 3.47362 14.722 2.0318C13.9279 2.01186 13.0248 2 12 2C8.51575 2 6.43945 2.13682 5.26285 2.26379C4.39116 2.35785 3.71902 2.94826 3.5558 3.80967C3.30175 5.15055 3 7.65725 3 12C3 16.3428 3.30175 18.8494 3.5558 20.1903C3.71902 21.0518 4.39116 21.6422 5.26285 21.7362C6.43945 21.8631 8.51575 22 12 22C15.4843 22 17.5606 21.8631 18.7372 21.7362C19.6089 21.6422 20.281 21.0518 20.4442 20.1903C20.6982 18.8494 21 16.3428 21 12C21 10.5445 20.9661 9.2952 20.9114 8.22695ZM8 13C7.4477 13 7 12.5523 7 12C7 11.4477 7.4477 11 8 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H8ZM8 17.5C7.4477 17.5 7 17.0523 7 16.5C7 15.9477 7.4477 15.5 8 15.5H15C15.5523 15.5 16 15.9477 16 16.5C16 17.0523 15.5523 17.5 15 17.5H8Z"
				fill={fillColor}
			/>
			<path
				d="M7 16.4995C7 17.0518 7.4477 17.4995 8 17.4995H15C15.5523 17.4995 16 17.0518 16 16.4995C16 15.9472 15.5523 15.4995 15 15.4995H8C7.4477 15.4995 7 15.9472 7 16.4995Z"
				fill={fillColor}
			/>
			<path
				d="M7 11.9995C7 12.5518 7.4477 12.9995 8 12.9995H12C12.5523 12.9995 13 12.5518 13 11.9995C13 11.4472 12.5523 10.9995 12 10.9995H8C7.4477 10.9995 7 11.4472 7 11.9995Z"
				fill={fillColor}
			/>
			<path
				d="M20.9114 8.22646C19.4717 8.58861 17.7718 8.61266 16.3036 8.16411C15.6828 7.97446 15.1988 7.49091 14.9893 6.87661C14.4674 5.34626 14.3384 3.47308 14.722 2.03125C14.722 2.03125 15.9461 2.49945 18.1961 4.74945C20.4461 6.99946 20.9114 8.22646 20.9114 8.22646Z"
				fill={fillColor}
			/>
		</svg>
	);
};
